import React, { useContext } from 'react';

import FiltersContext from './FiltersContext';
import { AreaConfig, useArea } from './hierarchy';
import { get } from './utils';

export interface FilterConfig extends AreaConfig {
  component: string | React.ComponentType<any>;
}

const Filter: React.FC<FilterConfig> = ({
  component,
  name,
  source,
  params,
  children,
  active = true,
  depends,
  ...props
}) => {
  const { setFieldValue, values } = useContext(FiltersContext);

  const area = useArea({
    name,
    source,
    params,
    depends,
    active,
  });

  const field = {
    value: get(values, name),
    onChange: (e: React.ChangeEvent<any>) => {
      const normalizedValue =
        e.target.value?.length === 0 ? undefined : e.target.value;
      setFieldValue(name, normalizedValue);
    },
  };

  return React.createElement(component, { field, area, ...props }, children);
};

export default Filter;
